import React from 'react';
import ReactDOM from 'react-dom';
import App from 'components/App';
import { getEntryPoint } from 'config/app';
import { PARAM_OFFICE_SELECTED, PARAM_INFO_BLOCKS, PARAM_LOADED_CALLBACK } from 'config/params';

export default ({ decorator = null } = {}) => {
  const {
    infoBlocks,
    selectedOfficeId,
    onModalContentLoaded
  } = window.abcpWidgetFranchiseesOfficesWindow || {};

  const props = {
    [PARAM_OFFICE_SELECTED]: selectedOfficeId ? Number(selectedOfficeId) : null,
    [PARAM_INFO_BLOCKS]: infoBlocks,
    [PARAM_LOADED_CALLBACK]: onModalContentLoaded,
  };

  try {
    const entryPointId = getEntryPoint();
    const entryPointDOM = document.getElementById(entryPointId);
    ReactDOM.render(
      React.createElement(decorator ? decorator(App) : App, {
        ...props
      }),
      entryPointDOM
    );
  } catch (e) {
    console.error(e);
  }
};
